import React, { useState, useEffect } from "react";

import Footer from "../Footer";
import Header from "./Header";
import Left_menu from "./Left_menu";

import axios from "axios";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

import config from "../../config";
import { useNetworkState } from "react-use";

import Create_order_nav_b2b from "./Create_order_nav_b2b";

import Create_order_steps_b2b from "./Create_order_steps_b2b";
import { Trash } from "lucide-react";
const Create_order_b2b_3 = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  const location = useLocation();
  //  console.log("location==>122", location)
  let parsed = queryString.parse(location.search);
  console.log("parsed === ", parsed);
  const safeParseJson = (encodedJson, defaultValue = []) => {
    try {
      if (!encodedJson) return defaultValue;
      const decoded = decodeURIComponent(encodedJson);
      return JSON.parse(decoded);
    } catch (e) {
      console.error("Error parsing JSON:", e);
      return defaultValue;
    }
  };
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const [products, setProducts] = useState([]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };
  const [state, setState] = React.useState({
    parcel_type: parsed.shipment_type || "Parcel",
    order_date: parsed.order_date || "",
    order_number: parsed.order_id || "",
    order_description: parsed.order_description || "",
    lr_number: parsed.lr_number || "",
    goods_code: parsed.goods_code || "",
  });
  const [invoiceDetails, setinvoiceDetails] = useState(
    safeParseJson(parsed.invoices, [
      {
        invoice_number: "",
        invoice_amount: "",
        invoice_ebn: "",
      },
    ])
  );
  console.log("invoiceDetails == ", invoiceDetails);

  const [orderNumber, setOrderNumber] = React.useState("");
  // const [numberOfBoxes, setNumberOfBoxes] = useState(boxDetails.length || 1);
  const [numberOfInvoices, setNumberOfInvoices] = useState(
    invoiceDetails.length || 1
  );
  console.log("numberOfInvoices ==", numberOfInvoices);
  const [paymentmode, setpaymentmode] = useState({
    mode:
      parsed.payment_mode === "cod"
        ? 2
        : parsed.payment_mode === "prepaid"
        ? 1
        : 1,
  });
  const [riskstate, setriskstate] = useState({
    risk:
      parsed.rv_insurance === "true"
        ? 2
        : parsed.rv_insurance === "false"
        ? 1
        : 2, // default value
  });

  const [selfstate, setselfstate] = useState({
    self: parsed.self === "true" ? 1 : parsed.self === "false" ? 2 : 1, // default value
  });
  const [orderErrors, setOrderErrors] = useState({});
  const [boxErrors, setBoxErrors] = useState([]);
  const [invoiceErrors, setInvoiceErrors] = useState([]);
  const [codvalueerror, setCodValueError] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState(() => {
    const parsedFiles = safeParseJson(parsed.documents, []);
    return parsedFiles.map((file) => ({
      ...file,
      isExisting: true, // Mark as existing file
      file: null, // No File object for existing files
    }));
  });
  console.log("uploadedFiles == ", uploadedFiles);
  const [fileErrors, setFileErrors] = useState({});
  // console.log("paymentmode",paymentmode)
  const [codvalue, setcodvalue] = useState({
    cod_amount: parseFloat(parsed.cod_amount) || 0,
    err: {},
  });

  const [boxDetails, setBoxDetails] = useState(
    safeParseJson(parsed.boxes, [
      {
        box_name: "",
        box_length: "",
        box_width: "",
        box_height: "",
        box_weight: "",
        quantity: "",
      },
    ])
  );

  const handleNumberOfInvoicesChange = (event) => {
    const newCount = parseInt(event.target.value);
    setNumberOfInvoices(newCount);

    if (newCount > invoiceDetails.length) {
      // Add new empty invoices
      setinvoiceDetails((prev) => [
        ...prev,
        ...Array.from({ length: newCount - prev.length }, () => ({
          invoice_number: "",
          invoice_amount: "",
          invoice_ebn: "",
        })),
      ]);
    } else if (newCount < invoiceDetails.length) {
      // Remove extra invoices (keep first newCount invoices)
      setinvoiceDetails((prev) => prev.slice(0, newCount));
    }
  };
  const generateOrderNumber = () => {
    // Generate the order number logic
    const randomNumber = Math.floor(Math.random() * 1000000);
    const formattedOrderNumber = +randomNumber;

    setOrderNumber(formattedOrderNumber);
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    let order_date = `${year}-${month}-${day}`;
    setState({
      ...state,
      order_number: formattedOrderNumber,
      order_date: order_date,
    });
  };
  const handleChange = (e) => {
    // console.log("namess",e.target.name)
    // console.log("value",e.target.value)

    let names = e.target.name;
    let value = e.target.value;

    if (e.target.type == "text") {
      setState({ ...state, [e.target.name]: value });
    } else if (e.target.type == "number") {
      setState({ ...state, [e.target.name]: value });
    } else if (e.target.type == "date") {
      setState({ ...state, [e.target.name]: value });
    } else {
      setState({ ...state, [e.target.name]: value });
    }
  };

  React.useEffect(() => {
    // Only generate new order number if we're not editing
    if (!parsed.order_id) {
      generateOrderNumber();
    }
    product_list();
  }, []);

  const product_list = () => {
    let dataToSend = {};

    let url = config.apiUrl + "/shipment/get_goods_items";

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        setProducts(res.data.output || []);
      })
      .catch(() => {});
  };

  const handleBoxDimensionChange = (event, key, index) => {
    const value =
      key === "quantity" || key === "unit_price"
        ? parseFloat(event.target.value)
        : event.target.value;
    setBoxDetails((prevState) => {
      const newState = [...prevState];
      newState[index][key] = value;
      return newState;
    });
  };

  const handleInvoiceDimensionChange = (event, key, index) => {
    const value = event.target.value;

    setinvoiceDetails((prevState) => {
      const newState = [...prevState];
      newState[index][key] = value; // Always store as string for controlled input
      return newState;
    });
  };

  const payment_mode = (e) => {
    if (e.target.name == "prepaid") {
      setpaymentmode({ mode: 1 });
    } else {
      setpaymentmode({ mode: 2 });
    }
  };

  const codvalueChange = (e) => {
    setcodvalue({ ...codvalue, cod_amount: e.target.value, err: {} });
  };
  const risk_mode = (e) => {
    if (e.target.name == "owner_risk") {
      setriskstate({ risk: 1 });
    } else {
      setriskstate({ risk: 2 });
    }
  };

  const self_mode = (e) => {
    if (e.target.name == "self_pickup") {
      setselfstate({ self: 1 });
    } else {
      setselfstate({ self: 2 });
    }
  };

  const handleFileUpload = (e, docType) => {
    const files = Array.from(e.target.files);
    setUploadedFiles((prev) => {
      // Remove any non-existing files of the same type
      const filtered = prev.filter(
        (file) => file.type !== docType || file.isExisting
      );

      // Add new files
      const newFiles = files.map((file) => ({
        file,
        type: docType,
        isExisting: false,
        name: file.name,
      }));

      return [...filtered, ...newFiles];
    });
  };

  // Add this function to remove an uploaded file
  const removeFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const next_step = async () => {
    // Validate basic order info
    if (
      !state.order_number ||
      !state.order_date ||
      !state.order_description
      // ||
      // !state.goods_code
    ) {
      setOrderErrors({
        order_number: !state.order_number ? "Order number is required" : "",
        order_date: !state.order_date ? "Order date is required" : "",
        // lr_number: !state.lr_number ? 'LR Number is required' : '',
        order_description: !state.order_description
          ? "Order Description is required"
          : "",
        // goods_code: !state.goods_code ? "Please select Goods" : "",
      });
      return;
    } else {
      setOrderErrors({});
    }

    // Validate box details
    const newBoxErrors = [];
    boxDetails.forEach((box, index) => {
      const errors = {};
      if (!box.box_length) errors.box_length = "Length is required";
      if (!box.box_width) errors.box_width = "Width is required";
      if (!box.box_height) errors.box_height = "Height is required";
      if (!box.box_weight) errors.box_weight = "Weight is required";
      if (!box.quantity) errors.quantity = "Quantity is required";
      // if (!box.product_name) errors.product_name = 'Product Name is required';
      // if (!box.unit_price) errors.unit_price = 'Unit price is required';
      newBoxErrors[index] = errors;
    });
    setBoxErrors(newBoxErrors);

    // Validate invoice details
    const newInvoiceErrors = [];
    invoiceDetails.forEach((invoice, index) => {
      const errors = {};
      if (!invoice.invoice_number)
        errors.invoice_number = "Invoice number is required";
      // if (!invoice.invoice_date) errors.invoice_date = 'Invoice Date is required';
      if (!invoice.invoice_amount)
        errors.invoice_amount = "Invoice Amount is required";
      if (invoice.invoice_amount > 50000 && !invoice.invoice_ebn) {
        errors.invoice_ebn =
          "E-Way Bill required for invoice greater than 50000 ";
      }
      newInvoiceErrors[index] = errors;
    });
    setInvoiceErrors(newInvoiceErrors);
    const Toast = Swal.mixin({
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 3000,
    });

    // Show first error message from invoice or box errors
    let firstError = null;

    // Check invoice errors
    for (let errObj of newInvoiceErrors) {
      const keys = Object.keys(errObj);
      if (keys.length > 0) {
        firstError = errObj[keys[0]];
        break;
      }
    }

    if (firstError) {
      Toast.fire({
        background: "#c2200a",
        icon: "error",
        title: firstError,
        color: "white",
      });
      return;
    }

    // Return if there are validation errors
    if (
      newBoxErrors.some((errors) => Object.keys(errors).length > 0) ||
      newInvoiceErrors.some((errors) => Object.keys(errors).length > 0)
    ) {
      return;
    }

    // Validate COD amount if payment mode is COD
    if (paymentmode.mode === 2 && codvalue.cod_amount <= 0) {
      setCodValueError("COD amount must be greater than 0");
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "#c2200a",
        type: "error",
        title: "COD amount must be greater than Zero",
        color: "white",
      });

      return;
    } else {
      setCodValueError("");
    }
    if (uploadedFiles.length === 0) {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "#c2200a",
        type: "error",
        title: "At least one document is required.",
        color: "white",
      });
      return;
    }

    // Create FormData object for file upload
    const formData = new FormData();

    // Append all regular form data
    formData.append("sender_name", parsed.sender_name);
    formData.append("sender_mobile", parsed.sender_mobile);
    formData.append("sender_email", parsed.sender_email);
    formData.append("sender_address", parsed.sender_address);
    formData.append("sender_city", parsed.sender_city);
    formData.append("sender_city_id", parsed.sender_city_id);
    formData.append("sender_country_name", parsed.sender_country);
    formData.append("sender_country_code", parsed.sender_country_code);
    formData.append("sender_postal_code", parsed.sender_postal_code);
    formData.append("receiver_name", parsed.receiver_name);
    formData.append("receiver_mobile", parsed.receiver_mobile);
    formData.append("receiver_email", parsed.receiver_email);
    formData.append("receiver_address", parsed.receiver_address);
    formData.append("receiver_city", parsed.receiver_city);
    formData.append("receiver_country_name", parsed.receiver_country);
    formData.append("receiver_country_code", parsed.receiver_country_code);
    formData.append("receiver_postal_code", parsed.receiver_postal_code);
    formData.append("receiver_city_id", parsed.receiver_city_id);
    formData.append("receiver_state_id", parsed.receiver_state_id);
    formData.append("sender_state_name", parsed.sender_state_name);
    formData.append("receiver_state_name", parsed.receiver_state_name);
    formData.append("return_name", parsed.return_name);
    formData.append("return_mobile", parsed.return_mobile);
    formData.append("return_email", parsed.return_email);
    formData.append("return_address", parsed.return_address);
    formData.append("return_city", parsed.return_city);
    formData.append("return_state_name", parsed.return_state_name);
    formData.append("return_country_name", parsed.return_country);
    formData.append("return_country_code", parsed.return_country_code);
    formData.append("return_postal_code", parsed.return_postal_code);
    formData.append("payment_mode", paymentmode.mode == 1 ? "prepaid" : "cod");
    formData.append("shipment_type", "Parcel");
    formData.append("cod_amount", codvalue.cod_amount);
    formData.append("address_id", parsed.sender_address_id);
    formData.append("order_id", state.order_number);
    formData.append("order_date", state.order_date);
    formData.append("lr_number", state.lr_number);
    formData.append("order_description", state.order_description);
    formData.append("goods_code", state.goods_code);

    formData.append("mode", parsed.mode);
    formData.append("rv_insurance", riskstate.risk == 2 ? "true" : "false");
    formData.append("self", selfstate.self == 1 ? "true" : "false");

    formData.append("carrier_type", "2");
    formData.append("customer_id", userData.customer_id);

    // Append boxes as JSON string
    formData.append("boxes", JSON.stringify(boxDetails));

    // Append invoices as JSON string
    formData.append("invoices", JSON.stringify(invoiceDetails));

    // Append uploaded files
    uploadedFiles.forEach((fileObj, index) => {
      formData.append(`documents[${index}][type]`, fileObj.type);

      if (fileObj.isExisting) {
        // For existing files, send their reference
        formData.append(`documents[${index}][isExisting]`, "true");
        formData.append(`documents[${index}][url]`, fileObj.url);
        formData.append(`documents[${index}][name]`, fileObj.name);
        if (fileObj._id) {
          formData.append(`documents[${index}][_id]`, fileObj._id);
        }
      } else {
        // For new files, append the File object
        formData.append(`documents[${index}][file]`, fileObj.file);
      }
    });

    try {
      const url = config.apiUrl + "/shipment/b2b_order_create";

      // Use axios with proper headers for FormData
      const response = await axios.post(url, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status == true) {
        window.location.replace(`/customer/b2b_orders`);
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#001b72",
          type: "success",
          title: "Order created successfully.",
          color: "white",
        });
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#c2200a",
          type: "error",
          title: "Something Went Wrong.",
          color: "white",
        });
      }
    } catch (error) {
      console.error("Error submitting order:", error);
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "#c2200a",
        type: "error",
        title: "Error submitting order. Please try again.",
        color: "white",
      });
    }
  };
  const handleAddBox = () => {
    setBoxDetails([
      ...boxDetails,
      {
        box_length: "",
        box_width: "",
        box_height: "",
        box_weight: "",
        quantity: "",
      },
    ]);
  };

  const handleRemoveBox = (indexToRemove) => {
    const updatedBoxes = boxDetails.filter(
      (_, index) => index !== indexToRemove
    );
    setBoxDetails(updatedBoxes);
  };
  return (
    <div>
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="home-section">
        <Header />

        <div class="row justify-content-between">
          <div class="col-12 col-md-4 desk_nav">
            <div class="d-flex">
              <a href="javascript:window.history.back();" class="back_btn">
                <i class="bi bi-arrow-90deg-left"></i>
              </a>
              <h2>Create Order</h2>
            </div>
          </div>
        </div>
        <Create_order_nav_b2b />
        <hr />
        <div class="row">
          <div class="col-12 col-md-2">
            <Create_order_steps_b2b value={3} />
          </div>

          <div class="col-12 col-md">
            <div class="card border-0 order_box">
              <div class="card-body">
                <section class="pb-3">
                  <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">
                        Order ID:{" "}
                        <small class="text-muted">
                          (Leave Blank for Auto Generate)
                        </small>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id=""
                        placeholder="Order ID"
                        value={state.order_number}
                        name="order_number"
                        onChange={(e) => handleChange(e)}
                      />
                      <span>{orderErrors.order_number}</span>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">
                        Order Date:
                      </label>
                      <input
                        type="date"
                        class="form-control"
                        id=""
                        placeholder="Enter Full Name"
                        value={state.order_date}
                        name="order_date"
                        onChange={(e) => handleChange(e)}
                      />
                      <span>{orderErrors.order_date}</span>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">
                        LR Number:
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id=""
                        placeholder="Enter LR Number"
                        value={state.lr_number}
                        name="lr_number"
                        onChange={(e) => handleChange(e)}
                      />
                      <span>{orderErrors.lr_number}</span>
                    </div>
                  </div>
                </section>
                <hr />
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label for="" class="form-label">
                      Order Description:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Order Description"
                      value={state.order_description}
                      name="order_description"
                      onChange={(e) => handleChange(e)}
                    />
                    <span>{orderErrors.order_description}</span>
                  </div>
                  {/* <div class="col-12 col-md-4">
                    <label for="" class="form-label">
                      Select Goods:
                    </label>
                    <select
                      className="form-select"
                      onChange={(e) => handleChange(e)}
                      name="goods_code"
                    >
                      <option>Select</option>
                      {products.map((item) => (
                        <option value={item.goods_code}>
                          {item.goods_code} - {item.goods_name}
                        </option>
                      ))}
                    </select>
                    <span>{orderErrors.goods_code}</span>
                  </div> */}
                </div>
                {boxDetails.map((box, index) => (
                  <div class="card mb-2" key={index}>
                    <div class="card-body">
                      <section class="">
                        <h6 class="mb-4">Box {index + 1} Detail</h6>
                        <div class="row">
                          <div class="col-12 col-md">
                            <label for="" class="form-label">
                              Box Dimensions (CM):
                            </label>
                            <div class="row g-1">
                              <div class="col-12 col-md mb-2">
                                <input
                                  type="number"
                                  className="form-control"
                                  id=""
                                  placeholder="Length"
                                  value={box.box_length}
                                  onChange={(e) =>
                                    handleBoxDimensionChange(
                                      e,
                                      "box_length",
                                      index
                                    )
                                  }
                                />
                                <span>{boxErrors[index]?.box_length}</span>
                              </div>
                              <div class="col-12 col-md mb-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  id=""
                                  placeholder="Width"
                                  name=""
                                  value={box.box_width}
                                  onChange={(e) =>
                                    handleBoxDimensionChange(
                                      e,
                                      "box_width",
                                      index
                                    )
                                  }
                                />
                                <span>{boxErrors[index]?.box_width}</span>
                              </div>
                              <div class="col-12 col-md mb-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  id=""
                                  placeholder="Height"
                                  name=""
                                  value={box.box_height}
                                  onChange={(e) =>
                                    handleBoxDimensionChange(
                                      e,
                                      "box_height",
                                      index
                                    )
                                  }
                                />
                                <span>{boxErrors[index]?.box_height}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-2">
                            <label for="" class="form-label">
                              Box Weight(KG):
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id=""
                              placeholder="Enter Weight"
                              name=""
                              value={box.box_weight}
                              onChange={(e) =>
                                handleBoxDimensionChange(e, "box_weight", index)
                              }
                            />
                            <span>{boxErrors[index]?.box_weight}</span>
                          </div>
                          <div class="col-12 col-md-2">
                            <label for="" class="form-label">
                              Box Quantity:
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id=""
                              placeholder="Enter quantity"
                              name=""
                              value={box.quantity}
                              onChange={(e) =>
                                handleBoxDimensionChange(e, "quantity", index)
                              }
                            />
                            <span>{boxErrors[index]?.quantity}</span>
                          </div>
                        </div>
                      </section>
                      <section class="pb-3">
                        <div class="row">
                          <div class="col-12 col-md-2 mb-3">
                            {index === 0 ? (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  style={{ marginTop: "30px" }}
                                  onClick={handleAddBox}
                                >
                                  Add Box
                                </button>
                              </>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                style={{ marginTop: "30px" }}
                                onClick={() => handleRemoveBox(index)}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                ))}

                <hr />
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label for="" class="form-label">
                      Number of Invoices:
                    </label>
                    <select
                      class="form-select form-select-sm"
                      onChange={handleNumberOfInvoicesChange}
                      value={numberOfInvoices}
                    >
                      {[...Array(10).keys()].map((num) => (
                        <option key={num + 1} value={num + 1}>
                          {num + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="card">
                  {invoiceDetails.map((invoice, index) => (
                    <div class="card-body" key={index}>
                      <h6>Invoice {index + 1}</h6>
                      <div class="row">
                        <div class="col-12 col-md">
                          <label for="" class="form-label">
                            Invoice Number:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="text"
                            placeholder="Invoice Number"
                            onChange={(e) =>
                              handleInvoiceDimensionChange(
                                e,
                                "invoice_number",
                                index
                              )
                            }
                            value={invoice.invoice_number}
                          />
                          <span>{invoiceErrors[index]?.invoice_number}</span>
                        </div>

                        <div class="col-12 col-md">
                          <label for="" class="form-label">
                            Invoice Amount:
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            id="text"
                            placeholder="Invoice Amount"
                            onChange={(e) =>
                              handleInvoiceDimensionChange(
                                e,
                                "invoice_amount",
                                index
                              )
                            }
                            value={invoice.invoice_amount}
                          />
                          <span>{invoiceErrors[index]?.invoice_amount}</span>
                        </div>
                        <div class="col-12 col-md">
                          <label for="" class="form-label">
                            E-Way Bill Number:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="text"
                            placeholder="Invoice E-Way Bill Number"
                            onChange={(e) =>
                              handleInvoiceDimensionChange(
                                e,
                                "invoice_ebn",
                                index
                              )
                            }
                            value={invoice.invoice_ebn}
                          />
                          <span className="text-danger">
                            {invoiceErrors[index]?.invoice_ebn}
                          </span>
                        </div>
                      </div>
                      <hr />
                    </div>
                  ))}
                </div>
                <hr />
                <section class="pb-3">
                  <h6 class="mb-1">Payment Details</h6>
                  <small class="">
                    Select mode of payment that your buyer has chosen for the
                    order
                  </small>
                  <div class="row mt-4">
                    <div class="col-12 col-md-2 mb-3">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="prepaid"
                          id="inlineRadio1"
                          value="option1"
                          onChange={(e) => payment_mode(e)}
                          checked={paymentmode.mode == 1}
                        />
                        <label class="form-check-label" for="inlineRadio1">
                          Prepaid{" "}
                          <a
                            href="#"
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-content="Payment already received from the Buyer"
                            class="text-muted"
                          >
                            <i
                              class="fa fa-question-circle-o"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </label>
                      </div>
                    </div>
                    <div class="col-12 col-md mb-3">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="cod"
                          id="inlineRadio1"
                          value="option1"
                          onChange={(e) => payment_mode(e)}
                          checked={paymentmode.mode == 2}
                        />
                        <label class="form-check-label" for="inlineRadio1">
                          COD (Cash on Delivery){" "}
                          <a
                            href="#"
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-content="COD payment will be credited to your account"
                            class="text-muted"
                          >
                            <i class="bi bi-question-circle"></i>
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>
                  {paymentmode.mode == 2 ? (
                    <div class="row">
                      <div class="col-12 col-md-5 mb-3">
                        <label class="form-check-label" for="inlineRadio1">
                          Collectible Amount
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          placeholder="Enter COD amount"
                          name="cod_amount"
                          onChange={(e) => codvalueChange(e)}
                          value={codvalue.cod_amount}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </section>
                <hr />
                <h6 class="mb-1">Insurance</h6>
                <small class="">Select insurance for the order</small>
                <div class="row mt-4">
                  <div class="col-12 col-md-6 mb-3">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="owner_risk"
                        id="inlineRadio1"
                        value="option1"
                        onChange={(e) => risk_mode(e)}
                        checked={riskstate.risk == 1}
                      />
                      <h6 class="form-check-label" for="inlineRadio1">
                        OR (Owner Risk)
                        <a
                          href="#"
                          data-bs-toggle="popover"
                          data-bs-placement="top"
                          data-bs-trigger="hover"
                          data-bs-content="Insurance charges will not apply to this order"
                          class="text-muted"
                        >
                          <i
                            class="fa fa-question-circle-o"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </h6>
                      <small class="">
                        {" "}
                        Max Cover : Only COF (Certificate of Fact)
                      </small>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="carrier_risk"
                        id="inlineRadio1"
                        value="option1"
                        onChange={(e) => risk_mode(e)}
                        checked={riskstate.risk == 2}
                      />
                      <h6 class="form-check-label" for="inlineRadio1">
                        CR (Carrier Risk){" "}
                        <a
                          href="#"
                          data-bs-toggle="popover"
                          data-bs-placement="top"
                          data-bs-trigger="hover"
                          data-bs-content="Insurance charges will be applied to this order."
                          class="text-muted"
                        >
                          <i
                            class="fa fa-question-circle-o"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </h6>
                      <small class="">
                        {" "}
                        Max Cover : 100% of invoice value , less processing
                        charges
                      </small>
                    </div>
                  </div>
                </div>
                <hr />

                {/* <div class="row mt-4">
                          <div class="col-12 col-md-6 mb-3">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="self_pickup" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 1} />
                              <h6 class="form-check-label" for="inlineRadio1">Pickup <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></h6>
                              <small>Pickup from my location</small>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-3">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="self_drop" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 2} />
                              <h6 class="form-check-label" for="inlineRadio1">Self Drop<a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></h6>
                              <small>I will self-drop at courier centre</small>
                            </div>
                          </div>
                        </div> */}
                <hr />
                <section className="pb-3">
                  <h6 className="mb-1">
                    Document Upload{" "}
                    <small className="text-danger">
                      Upload Document type (PNG,JPG,JPEG,PDF,BMP)
                    </small>
                  </h6>
                  <small className="text-muted">
                    Atleast one document is mandatory to upload{" "}
                  </small>

                  <div className="row mt-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Invoice:</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileUpload(e, "invoice")}
                        multiple
                      />
                      {fileErrors.invoice && (
                        <div className="text-danger small">
                          {fileErrors.invoice}
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Delivery Challan:</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) =>
                          handleFileUpload(e, "delivery_challan")
                        }
                        multiple
                      />
                      {fileErrors.delivery_challan && (
                        <div className="text-danger small">
                          {fileErrors.delivery_challan}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Declaration:</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileUpload(e, "declaration")}
                        multiple
                      />
                      {fileErrors.declaration && (
                        <div className="text-danger small">
                          {fileErrors.declaration}
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">
                        Other Supporting Documents:
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileUpload(e, "other")}
                        multiple
                      />
                      {fileErrors.other && (
                        <div className="text-danger small">
                          {fileErrors.other}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Display uploaded files */}
                  {uploadedFiles.length > 0 && (
                    <div className="mt-3">
                      <h6>Uploaded Documents:</h6>
                      <ul className="list-group">
                        {uploadedFiles.map((fileObj, index) => (
                          <li
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <span className="badge bg-secondary me-2">
                                {fileObj.type}
                              </span>
                              {fileObj.file ? fileObj.file.name : fileObj.name}
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeFile(index)}
                            >
                              <Trash />
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </section>
                <hr />
              </div>
            </div>
            <div class="py-4 text-end">
              {/* <a onClick={() => navigate({
                        pathname: `/customer/create_order_2`,
                        search: `sender_name=${parsed.sender_name}&sender_address=${parsed.sender_address}&sender_country=${parsed.sender_country}&sender_country_code=${parsed.sender_country_code}&sender_postal_code=${parsed.sender_postal_code}&sender_state_name=${parsed.sender_state_name}&sender_city=${parsed.sender_city}&sender_address_id=${parsed.sender_address_id}&sender_city_id=${parsed.sender_city_id}&sender_mobile=${parsed.sender_mobile}&sender_email=${parsed.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&return_name=${parsed.return_name}&return_email=${parsed.return_email}&return_mobile=${parsed.return_mobile}&return_address=${parsed.return_address}&return_country=${parsed.return_country}&return_country_code=${parsed.return_country_code}&return_postal_code=${parsed.return_postal_code}&return_city=${parsed.return_city}&return_state_name=${parsed.return_state_name}&mode=${parsed.mode}&items=${parsed.items}&shipment_type=${state.parcel_type}&order_id=${state.order_number}&order_date=${state.order_date}&cod_amount=${codvalue.cod_amount}&payment_mode=${paymentmode.mode == 1 ? "prepaid" : "cod"}&weight=${parsed.weight ? parsed.weight : ""}&height=${parsed.height ? parsed.height : ""}&width=${parsed.width ? parsed.width : ""}&length=${parsed.length ? parsed.length : ""}&store_id=${parsed.store_id ? parsed.store_id : ""}&channel_name=${parsed.channel_name ? parsed.channel_name : ""}&volumetric_weight=${parsed.volumetric_weight ? parsed.volumetric_weight : ""}&dead_weight=${parsed.dead_weight ? parsed.dead_weight : ""}&receiver_state_id=${parsed.receiver_state_id}&receiver_city_id=${parsed.receiver_city_id}&carrier_type=${parsed.carrier_type}`
                      })} class="btn btn-secondary me-2">Back</a> */}
              <a class="btn btn-primary" onClick={(e) => next_step()}>
                Next
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Create_order_b2b_3;
